export type AdminLicenseSummary = {
  license_tiers: string[]
  total_devices: number
  annual_quota_km2: number
}

type PersonalLicense = {
  user_id: string
  license_tier: string
  total_devices: number
  annual_quota_km2: number
}

/** Summarize every eligible personal entitlement, independent of query order. */
export function summarizePersonalLicenses(licenses: readonly PersonalLicense[]): Map<string, AdminLicenseSummary> {
  const summaries = new Map<string, AdminLicenseSummary>()
  for (const license of licenses) {
    let summary = summaries.get(license.user_id)
    if (!summary) {
      summary = { license_tiers: [], total_devices: 0, annual_quota_km2: 0 }
      summaries.set(license.user_id, summary)
    }
    summary.total_devices += license.total_devices
    summary.annual_quota_km2 += license.annual_quota_km2
    if (!summary.license_tiers.includes(license.license_tier)) {
      summary.license_tiers.push(license.license_tier)
    }
  }
  for (const summary of summaries.values()) {
    summary.license_tiers.sort()
  }
  return summaries
}
